import {
  differenceInMilliseconds,
  setDate,
  setHours,
  setMinutes,
  setMonth,
  setSeconds
} from 'date-fns';
import type { ScheduleSolversTimeConfigType } from '../../types';

export const annuallyOnTime = ({
  startDate,
  endDate,
  userDate
}: ScheduleSolversTimeConfigType) => {
  const viewDuration = differenceInMilliseconds(endDate, startDate);

  const startDateMonth = startDate.getMonth();
  const startDateDay = startDate.getDate();
  const startHour = startDate.getHours();
  const startMinutes = startDate.getMinutes();
  const startSeconds = startDate.getSeconds();

  const startDateInThisYear = setDate(
    setMonth(
      setHours(
        setMinutes(setSeconds(userDate, startSeconds), startMinutes),
        startHour
      ),
      startDateMonth
    ),
    startDateDay
  );

  const endDateInThisYear = new Date(
    startDateInThisYear.getTime() + viewDuration
  );

  return endDateInThisYear.getTime() - userDate.getTime();
};
